module.exports = __webpack_public_path__ + "static/media/stijn-bessem-portfolio-digital-mountain-front-2560x400.65cd9060.png";